import { combineReducers } from 'redux';
import userSession from './userSession';
import signInModal from './signInModal';
import signIn from './signIn';
import signUp from './signUp';
import signUpBusiness from './signUpPro';
import firstSignIn from './firstSignIn';
import forgotPassword from './forgotPassword';
import account from './account';
import booking from './booking';
import quotation from './quotation';
import invoices from './invoices';

const rootReducer = combineReducers({
    userSession,
    signInModal,
    signIn,
    signUp,
    signUpBusiness,
    firstSignIn,
    forgotPassword,
    account,
    booking,
    quotation,
    invoices
});

export default rootReducer;
